import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LogoutModal from "../components/LogoutModal";
import Meta from "../components/Meta";
// eslint-disable-next-line
import { toast, ToastContainer } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.min.css";
import Loader from "../components/Loader";
import {  Table } from "react-bootstrap";

const AccompanyScreen = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");
  const [situacao, setSituacao] = useState("");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  // eslint-disable-next-line
  useEffect(() => {
   
    if (userInfo.cpf) {
      let theDate = new Date(Date.parse(userInfo.updatedAt));
      setData(theDate.toLocaleDateString());

      if (userInfo.statusDoc === 1) {
        setSituacao(<span className="badge badge-warning">ANALISANDO</span>);
      } else if (userInfo.statusDoc === 2) {
        setSituacao(<span className="badge badge-success">LIBERADO</span>);
      } else if (userInfo.statusDoc === 3) {
        setSituacao(<span className="badge badge-secondary">RECUSADO</span>);
      }

      setLoading(true);
      setTimeout(function () {
        /*código a ser executado no tempo informado*/
        setLoading(false);
      }, 1000);
    }
  }, );

  return (
    <>
      <ToastContainer />
      <Meta />

      <div id="wrapper">
        <Sidebar />

        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />

            {loading ? (
              <Loader />
            ) : (
              <div className="container-fluid">
                <div className="d-sm-flex align-items-center justify-content-between mb-4">
                  <h1 className="h3 mb-0 text-gray-800">Acompanhamento </h1>
                </div>

                {userInfo.statusDoc === 0 ? (
                  <></>
                ) : (
                  <>
                    <Table
                      striped
                      bordered
                      hover
                      responsive
                      className="table-sm"
                    >
                      <thead>
                        <tr>
                          <th>NOME</th>
                          <th>STATUS</th>
                          <th>DATA DA SOLICITAÇÃO</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{userInfo.nome}</td>
                          <td>{situacao}</td>

                          <td>{data}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </>
                )}
              </div>
            )}
          </div>

          <Footer />
        </div>
      </div>
      <LogoutModal />
    </>
  );
};
export default AccompanyScreen;
